import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const ACSSPaymentMethodSchema = z.object({
    bankName: z.string(),
    last4: z.string(),
    institutionNumber: z.string(),
    fingerPrint: z.string(),
    transitNumber: z.string(),
});

export class ACSSPaymentMethod extends FromSchema(ACSSPaymentMethodSchema) {
    fingerPrint: string;
    bankName: string;
    last4: string;
    institutionNumber: string;
    transitNumber: string;
}
